<template>
  <div>
    <v-row dense class="mx-1 mt-1" v-if="initialSelectionCount > 0 ">
      <v-col cols="12">
        <v-alert
          type="success"
          outlined
          v-once
          class="rounded-tag-small body-2"
          dismissible>
        Selecionamos {{ initialSelectionCount }} {{ fornecedor }} baseado nos produtos cotados
        </v-alert>
      </v-col>
    </v-row>
    <v-row dense class="mx-1 mt-1">
      <span class="caption mt-2">{{ values.length }} selecionado(s)</span>
        <v-btn v-if="values.length"
               x-small text
               class="normal-btn-text mt-2"
               color="error"
               @click="onClickClose">
          <v-icon x-small>mdi-close</v-icon>
          limpar
        </v-btn>
      <v-spacer/>
      <px-fornecedor-filter ref="filtersMenu" :filters="filters"
                            @change="onUpdateAdvancedFilters"/>
      <px-search-text ref="searchText"
                      label="Busque por documento, fornecedor ou código interno."
                      v-model="filters.searchText"
                      class="rounded-tag-small"
                      style="max-width: 500px"
                      :on-search="onUpdateFilters"/>
    </v-row>
    <px-selecao-fornecedores-selecionados :fornecedores="values"
                                          @remove="onRemoveItem"/>
  </div>
</template>

<script>
import PxSelecaoFornecedoresSelecionados
  from '@/components/lista-selecao-fornecedor/PxSelecaoFornecedoresSelecionados.vue';
import PxFornecedorFilter from './PxFornecedorFilter.vue';

export default {
  props: {
    initialSelectionCount: {
      type: Number,
    },
    values: Array,
  },
  data() {
    return {
      filters: {
        searchText: null,
        estados: [],
        municipios: [],
        cnaes: [],
      },
      alert: true,
    };
  },
  computed: {
    fornecedor() {
      return this.values.length > 1 ? 'fornecedores' : 'fornecedor';
    },
  },
  methods: {
    onUpdateAdvancedFilters({ estados, municipios, cnaes }) {
      this.filters.estados = estados;
      this.filters.municipios = municipios;
      this.filters.cnaes = cnaes;
      this.onUpdateFilters();
    },
    onUpdateFilters() {
      this.$emit('change', this.filters);
    },
    onClickClose() {
      this.$emit('resetfornecedor');
    },
    onRemoveItem(fornecedor) {
      this.$emit('remove', fornecedor);
    },
    openFilters() {
      this.$refs.filtersMenu.open();
    },
    focusOnSearchText() {
      const searchTextContainer = this.$refs.searchText;
      const searchInput = searchTextContainer.$el.querySelector('input');
      if (searchInput) {
        searchInput.focus();
      }
    },
  },
  components: {
    PxFornecedorFilter,
    PxSelecaoFornecedoresSelecionados,
  },
};
</script>
